import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore,collection} from "firebase/firestore"

// const firebaseConfig = {
//   apiKey: "AIzaSyC3SaazYyrwv_9lmZ52JUz5LVPWov_xA9k",
//   authDomain: "jusride-storemanager.firebaseapp.com",
//   projectId: "jusride-storemanager",
//   storageBucket: "jusride-storemanager.firebasestorage.app",
//   messagingSenderId: "345676701899",
//   appId: "1:345676701899:web:b0b37e090307f4a5087b4e",
//   measurementId: "G-ZBY2Y05HD4",
// };
const firebaseConfig = {
  apiKey: "AIzaSyB3M7aJoo77Gvut06g5tCCdOqslqKkT-m4",
  authDomain: "jusride-admin.firebaseapp.com",
  projectId: "jusride-admin",
  storageBucket: "jusride-admin.firebasestorage.app",
  messagingSenderId: "457681378470",
  appId: "1:457681378470:web:cadeafd06166c6e0412867",
  measurementId: "G-M44YRLBXBF"
};

const app = initializeApp(firebaseConfig);

// Initialize Analytics
// export const analytics = getAnalytics(app);

export const db = getFirestore(app);





